<template>
    <div id="jh_login">
        <div class="apply_tit">G买卖交易行&nbsp;&nbsp;&nbsp;申请</div>
        <div class="apply_ph">
            <p>获取你的手机号</p>
            <p>获取手机号用于快捷登录/注册</p>
        </div>
        <div class="phone_num">
            <div class="phone">{{ mobile |  plusX}}</div>
            <van-icon name="success" color="var(--success)" />
        </div>
        <div class="btns">
            <el-button @click="cancle">取消</el-button>
            <el-button type="primary" :loading="loading>0" @click="allow">允许</el-button>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['selection'],
        data() {
            return {
                loading: 0,
                account: '',
                mobile: '',
                user_id: ''
            }
        },
        filters: {
            plusX(str) {
                var x = "****";
                if (str.length >= 6) {
                    return (
                        str.substring(0, 3) + x + str.substring(str.length - 4, str.length)
                    );
                } else {
                    return str;
                }
            },
        },
        computed: {
            juhe_user_id() {
                return this.$route.query.ju
            },
            app_key() {
                return this.$route.query.app_key
            },
            isAndroid() {
                var u = navigator.userAgent;
                if (u.indexOf("Android") > -1 || u.indexOf("Adr") > -1) {
                    return true
                } else {
                    return false
                }
            },
        },
        mounted() {
            this.$nextTick(() => {
                this.findUserinfo()
            })
        },
        methods: {
            cancle() {
                this.$parent.handleClose()
            },
            findUserinfo() {
                this.$Ajax('user-info/find-userinfo', {
                    juhe_user_id: this.juhe_user_id,
                    app_key: this.app_key
                }, 'get').then(rs => {
                    if (rs.code == 200) {
                        this.mobile = rs.data.mobile
                    }
                })
            },
            allow() {
                var that = this
                this.loading++
                this.$Ajax('user-info/quick-register', {
                    juhe_user_id: this.juhe_user_id,
                    app_key: this.app_key,
                    platform: this.platform
                }).then(rs => {
                    if (rs.code == 200) {
                        this.$store.dispatch("setCookies", rs.data);
                        if (this.isAndroid) {
                            try {
                                window.android.sendUserInfoWebToNative(JSON.stringify(rs.data));
                            } catch (error) {
                                console.log(error);
                            }
                        } else {
                            try {
                                window.webkit.messageHandlers.sendUserInfoWebToNative.postMessage(JSON.stringify(rs.data));
                            } catch (error) {
                                console.log(error);
                            }
                        }
                        this.$toast({
                            message: rs.msg,
                            duration: "2000",
                            onClose: () => {
                                if(this.selection.path && this.selection.path != "/user/login" && this.selection.path != '/') {
                                    this.$router.go(-2)
                                }else {
                                    this.$router.push({
                                        path: '/'
                                    });
                                }
                            },
                        });
                    }
                }).finally(() => {
                    setTimeout(() => {
                        that.loading = 0
                    }, 2000)
                })
            }
        },
    }
</script>
<style lang="less" scoped>
    #jh_login {
        padding: 2rem 2rem 3rem;

        .apply_tit {
            font-size: 1.6rem;
            color: #000;
            font-weight: 700;
            margin-bottom: 1.2rem;
        }

        .apply_ph {
            margin-bottom: 1.6rem;

            p:nth-child(1) {
                font-size: 1.8rem;
                font-weight: 700;
                margin-bottom: 0.5rem;
            }

            p:nth-child(2) {
                font-size: 1.5rem;
                color: #999;
            }
        }

        .phone_num {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 2.4rem;
            margin-bottom: 1.6rem;
            padding: 1rem 0;
            border-top: 1px solid #eee;
            border-bottom: 1px solid #eee;

            .phone {
                font-size: 1.6rem;
            }
        }

        .btns {
            display: flex;
            justify-content: center;
            align-items: center;

            .el-button {
                width: 12rem;
                height: 3.6rem;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 1.4rem;
            }

            .el-button+.el-button {
                margin-left: 3rem;
            }
        }
    }
</style>